import { render, staticRenderFns } from "./HistoryEmpty.vue?vue&type=template&id=3cef7baf&scoped=true&"
import script from "./HistoryEmpty.vue?vue&type=script&lang=js&"
export * from "./HistoryEmpty.vue?vue&type=script&lang=js&"
import style0 from "./HistoryEmpty.vue?vue&type=style&index=0&id=3cef7baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cef7baf",
  null
  
)

/* custom blocks */
import block0 from "./HistoryEmpty.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports